import React from 'react';
import './landing.css';
import AppearingElement from "../Helper/AppearingElement";
import { Typography, Grid } from "@material-ui/core";
import screen from "./images/zipeditor.png";

class SlideSection extends React.Component {
    render() {
        return (
            <div className="slide-section">
                <Grid container spacing={1}>
                    <Grid item sm={12} md={6}>
                        <AppearingElement>
                            <Typography variant="h3" className="slide-section__title">{this.props.title}</Typography>
                        </AppearingElement>
                        <AppearingElement>
                            <Typography variant="h5" className="slide-section__sub-title">{this.props.subtitle}</Typography>
                        </AppearingElement>
                    </Grid>
                    <Grid item sm={12} md={6}>
                        <div className="slide-section__screen" >
                            <img src={screen} alt="" />
                        </div>
                    </Grid>
                </Grid>
            </div>
        )
    }

}

export default SlideSection;